module.exports = __webpack_public_path__ + "img/publicity.4e33ebb7.jpg";